<template>
  <div class="account-balance">
    <Row class="account-balance__row account-balance__row--mobile">
      <template #top-left>
        <SkeletonLoader
          v-if="isLoading"
          data-testid="refresh-account-balance-loader"
          class="account-balance__refresh-loader"
        >
          <div />
        </SkeletonLoader>
        <BaseText v-else>{{ totalBalance }}</BaseText>
      </template>
      <template #top-right>
        <div class="account-balance__container--mobile">
          <div class="account-balance__refresh-container--mobile">
            <button
              aria-label="Atualizar saldo"
              :disabled="isLoading"
              data-testid="btn-refresh-balance"
              @click="refreshBalance"
            >
              <BaseIcon
                width="20px"
                height="20px"
                :icon="getIcon"
                :colors="NebraskaColors.elementSecondary"
                :spin="isLoading"
              />
            </button>
          </div>
        </div>
      </template>
      <template #bottom-left>
        <BaseText size="sm" :color="NebraskaColors.textSecondary">
          {{ rowDescription }}
        </BaseText>
      </template>
    </Row>

    <Row class="account-balance__row account-balance__row--desktop">
      <template #top-left>
        <BaseText>{{ rowDescription }}</BaseText>
      </template>

      <template #top-right>
        <div class="account-balance__container">
          <SkeletonLoader
            v-if="isLoading"
            data-testid="refresh-account-balance-loader"
            class="account-balance__refresh-loader"
          >
            <div />
          </SkeletonLoader>
          <BaseText v-else>{{ totalBalance }}</BaseText>
          <div class="account-balance__refresh-container">
            <button
              aria-label="Atualizar saldo"
              :disabled="isLoading"
              data-testid="btn-refresh-balance"
              @click="refreshBalance"
            >
              <BaseIcon
                width="20px"
                height="20px"
                :icon="getIcon"
                :colors="NebraskaColors.elementSecondary"
                :spin="isLoading"
              />
            </button>
          </div>
        </div>
      </template>
    </Row>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import {
  BaseIcon,
  BaseText,
  Row,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';

@Component({
  name: 'AccountBalance',
  components: { BaseText, Row, SkeletonLoader, BaseIcon }
})
export default class AccountBalance extends Vue {
  @Prop({ type: Boolean, default: true })
  private isLoading!: boolean;

  @Prop({ type: String, required: false })
  private totalBalance?: string;

  private get rowDescription() {
    return 'Saldo disponível em conta';
  }

  private refreshBalance() {
    this.$emit('refresh-balance');
  }

  private get getIcon() {
    return this.isLoading ? 'ic_settings' : 'ic_redo';
  }

  private get NebraskaColors() {
    return NebraskaColors;
  }
}
</script>

<style lang="less" scoped>
.account-balance {
  &__row {
    margin-top: @size-spacing-x300;
  }

  &__row--desktop {
    display: none;
  }

  &__container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &__refresh-loader {
    width: 100px;
    > div {
      background: @background-tertiary;
      height: 28px;
      border-radius: 10px;
    }
  }

  &__refresh-container {
    display: flex;
    align-items: center;
    padding-left: 4px;
    button {
      outline: none;
    }
    /deep/ span {
      display: flex;
    }
    &--mobile {
      button {
        outline: none;
      }
      /deep/ span {
        display: flex;
      }
    }
  }

  @media (min-width: 30em) /* 480px */ {
    &__row,
    &__loader {
      margin-top: @size-spacing-x500;
    }

    &__row--mobile {
      display: none;
    }

    &__row--desktop {
      display: block;
    }
  }
}
</style>
